import React from "react";
import { Label as UI5Label } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

export function Label({
  className,
  required = false,
  showColon = false,
  children,
  ...props
}) {
  return (
    <UI5Label
      required={required}
      showColon={showColon}
      className={cn(
        "block mb-2", // Block display with bottom margin
        className
      )}
      {...props}
    >
      {children}
    </UI5Label>
  );
}
